
import XHeader from 'vux/src/components/x-header/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'


export default {
components: {
XHeader,
Cell,
Group,
Confirm
},
data() {
return {
info: '',
showConfirm: false,
value2: '',
editField: ''
}
},
mounted: function () {
document.title = '个人设置'
this.$nextTick(function () {
const url = this.tianYiWebUrl + '/wechat/uc/index'
this.$http.get(url).then(r => {
this.info = r.data.data.userInfo
this.info.orderNumber = r.data.data.orderNumber
})
})
},

methods: {
onCancel() {
},
onHide() {

this.value2 = ''
this.editField = ''
},
onShow() {
this.$refs.confirm1.setInputValue(this.value2)
},
onConfirm(value) {
const url = this.tianYiWebUrl + '/wechat/uc/ajaxChangeField'
this.$http.post(url, {params: {[this.editField]: value}}).then(r => {
let res = r.data
if (res.code === 200) {
let key = Object.keys(res.data)[0]
this.info[key] = res.data[key]
}
if(res.code === 500) {
this.$vux.alert.show(res.message)
}
})
},
edit(type) {
this.showConfirm = true
if (type === 'wechat') {
this.editField = 'wechat'
this.value2 = this.info.wechat
}
if (type === 'trueName') {
this.editField = 'true_name'
this.value2 = this.info.true_name
}

}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/Setting.vue